{
    "name": "dark",
    "primary": "#60a5fa",
    "secondary": "#a78bfa",
    "success": "#4ade80",
    "error": "#f87171",
    "warning": "#fbbf24",
    "text": "#e5e7eb",
    "textDim": "#6b7280",
    "textMuted": "#9ca3af",
    "secondaryText": "#999999",
    "border": "#374151",
    "background": "",
    "accent": "#818cf8",
    "toolName": "#60a5fa",
    "toolSuccess": "#4ade80",
    "toolError": "#f87171",
    "diffAdded": "#4ade80",
    "diffRemoved": "#f87171",
    "diffContext": "#6b7280",
    "diffAddedDimmed": "#47584a",
    "diffRemovedDimmed": "#69484d",
    "diffAddedWord": "#38a660",
    "diffRemovedWord": "#b3596b",
    "diffAddedWordDimmed": "#2e6b3a",
    "diffRemovedWordDimmed": "#8b3945",
    "diffAddedBackground": "#16a34a",
    "diffAddedBackgroundText": "#ffffff",
    "diffAddedBackgroundWord": "#bbf7d0",
    "diffRemovedBackground": "#dc2626",
    "diffRemovedBackgroundText": "#ffffff",
    "diffRemovedBackgroundWord": "#fecaca",
    "spinnerColor": "#60a5fa",
    "claude": "#d77757",
    "claudeShimmer": "#eb9f7f",
    "permission": "#b1b9f9",
    "permissionShimmer": "#cfd7ff",
    "inputPrompt": "#60a5fa",
    "footerText": "#6b7280",
    "commandColor": "#818cf8",
    "planPrimary": "#f59e0b",
    "planBorder": "#92400e",
    "subtle": "#4b5563",
    "link": "#60a5fa",
    "code": "#e2b553",
    "subagent1": "#dc2626",
    "subagent2": "#2563eb",
    "subagent3": "#16a34a",
    "subagent4": "#ca8a04",
    "subagent5": "#9333ea",
    "subagent6": "#ea580c",
    "subagent7": "#db2777",
    "subagent8": "#0891b2",
    "language": "#2dd4bf"
}
